import { render, staticRenderFns } from "./GroupSurveyPage.vue?vue&type=template&id=cb1383a2&scoped=true"
import script from "./GroupSurveyPage.vue?vue&type=script&lang=js"
export * from "./GroupSurveyPage.vue?vue&type=script&lang=js"
import style0 from "./GroupSurveyPage.vue?vue&type=style&index=0&id=cb1383a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1383a2",
  null
  
)

export default component.exports